function Navbar() {
  return (
    <nav className="container-fluid">
      <div className="page-wrapper d-flex align-items-center justify-content-center py-3">
        
        {/* Left: Name / Logo */}
        {/* <div>
          <span style={{ fontWeight: 500 }}>Your Name</span>
        </div> */}

        {/* Right: Navigation */}
        <div className="d-flex gap-5">
          <a href="/">Home</a>
          <a href="/projects">Projects</a>
          <a href="/research">Research</a>
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;
